import { createMessage } from '@goodhabitz/learning-activity-communication';
export const transformToActivityMessage = (ghccMessage) => {
    const messageType = ghccMessage.data.Function;
    const payload = ghccMessage.data.Data;
    return createMessage(messageType, payload);
};
//# sourceMappingURL=transformToActivityMessage.js.map